import React from 'react';
import { Icon, Link } from '@hz-design-system/web-ui';
import Classes from '../ProfileSidebar.module.scss';

const EmailInfo = ({ email }: { email: string }) => (
  <li className={Classes.infoWrap}>
    <Icon name="email" />
    <Link href={`mailto:${email}`}>{email}</Link>
  </li>
);

export default EmailInfo;
